import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-2xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-14 h-14 mx-auto text-[#2E8A57]" />
      <h1 className="font-serif-display font-bold text-3xl mt-6">Pagamento annullato</h1>
      <p className="mt-3 text-[#78716C]">Nessun addebito effettuato. I tuoi piatti ti aspettano nel carrello.</p>
      <Link to="/checkout" data-testid="retry-checkout-btn" className="btn-tuscan inline-block mt-10 px-8 py-4 rounded-full text-sm font-semibold">Riprova il checkout</Link>
    </div>
  );
}
